import { render, staticRenderFns } from "./SubmissionSubtitle.vue?vue&type=template&id=30ddda90&"
import script from "./SubmissionSubtitle.vue?vue&type=script&lang=js&"
export * from "./SubmissionSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports